export const ART_ITEM = 'ART_ITEM'
export const FURNITURE_ITEM = 'FURNITURE_ITEM'

export const GEOMETRY_TYPE_MAP = {
    '2d_wall': ART_ITEM,
    '3d': FURNITURE_ITEM,
}

export type RenderType = ('ART_ITEM' | 'FURNITURE_ITEM')
